import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage('secret-key-value');

export const doNotEncryptStorage = new EncryptStorage('secret-key-value', {
  doNotEncryptValues: true,
});
